import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { File } from './file';
import { SignedDocument } from './signed-document';

export class SignedDocumentFile extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static SignedDocumentFileProperties: (
    | {
        property: keyof SignedDocumentFile;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof SignedDocumentFile;
        type: 'alias';
      }
    | {
        property: keyof SignedDocumentFile;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'SignedDocumentId', type: 'column', dataType: 'number' },
    { property: 'FileId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    {
      property: 'SignedDocument',
      model: 'SignedDocument',
      type: 'association'
    },
    { property: 'File', model: 'File', type: 'association' }
  ];

  static {
    SignedDocumentFile.SignedDocumentFileProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          SignedDocumentFile.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          SignedDocumentFile.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          SignedDocumentFile.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(SignedDocumentFileObject: Partial<SignedDocumentFile>) {
    super();

    SignedDocumentFile.SignedDocumentFileProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = SignedDocumentFileObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  SignedDocumentId?: number;
  FileId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  SignedDocument?: SignedDocument;
  File?: File;
}
